import PropTypes from "prop-types";
import React, { useState, useContext, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import styles from "./navStyles.module.css";
import account from "../../assets/images/navbar/Users.svg";
import company from "../../assets/images/navbar/Company.svg";
import invoice from "../../assets/images/navbar/Invoices.svg";
import history from "../../assets/images/navbar/History.svg";
import report from "../../assets/images/navbar/Report.svg";
import logout from "../../assets/images/navbar/logout.svg";
import iconDown from "../../assets/images/navbar/IconDown.svg";
import task from "../../assets/images/navbar/Tasks.svg";
import help from "../../assets/images/navbar/Help.svg";
import collapse1 from "../../assets/images/navbar/CollapseClose.svg";
import collapse2 from "../../assets/images/navbar/CollapseOpen.svg";
import mkaegoodIcon from "../../assets/images/navbar/MakeGoodIcon.svg";
import invoiceLite from "../../assets/images/navbar/InvoicesLite.svg";
import mgTextNew from "../../assets/images/navbar/MakeGoodTextNew.svg";
import historyLite from "../../assets/images/navbar/HistoryLite.svg";
import accountLite from "../../assets/images/navbar/UserLite.svg";
import helpLite from "../../assets/images/navbar/HelpLite.svg";
import reportLite from "../../assets/images/navbar/ReportLite.svg";
import taskLite from "../../assets/images/navbar/TasksLite.svg";
import companyLite from "../../assets/images/navbar/CompanyLite.svg";
import switchIcon from "../../assets/images/navbar/switchIcon.svg";
import settingsIcon from "../../assets/images/navbar/settingsIcon.svg";
import teamIcon from "../../assets/images/navbar/teamIcon.svg";
import onboardIcon from "../../assets/images/navbar/onboardIcon.svg";
import { useNavContext } from "../../Context/NavContext";
import iconUpLite from "../../assets/images/navbar/IconUpLite.svg";
import OnboardingContext from "../../Context/OnboardingContext";
import Recurring_Approval_icon from "../../assets/icons/Recurring_Approval_icon.svg";
import PaymentIconActive from "../../assets/icons/PaymentDepositBlue.svg";
import PaymentIconInactive from "../../assets/icons/PaymentDepositWhite.svg";
import PayoutIcon from "../../assets/icons/PayoutIcon.svg";
import PayoutIconWhite from "../../assets/icons/PayoutIconWhite.svg";

export const NAV_ITEMS = [
  {
    text: "Payments",
    path: "/client/payments",
    icon: PaymentIconActive,
    iconLite: PaymentIconInactive,
    id: "paymentLite",
  },
  {
    text: "Accounts",
    path: "/client/accounts",
    icon: account,
    iconLite: accountLite,
    id: "accountLite",
  },
  {
    text: "Tasks",
    path: "/client/tasks",
    icon: task,
    iconLite: taskLite,
    id: "taskLite",
  },
  {
    text: "Reports",
    path: "/client/reports",
    icon: report,
    iconLite: reportLite,
    id: "reportLite",
  },
  {
    text: "History",
    path: "/client/history",
    icon: history,
    iconLite: historyLite,
    id: "historyLite",
  },
  {
    text: "Payouts",
    path: "/client/payouts",
    icon: PayoutIcon,
    iconLite: PayoutIconWhite,
    id: "payoutLite",
  },
  {
    text: "Help",
    path: "/client/help",
    icon: help,
    iconLite: helpLite,
    id: "helpLite",
  },
];

export const INVOICE = {
  text: "Invoices",
  icon: invoice,
  iconLite: invoiceLite,
  id: "invoiceLite",
  subLink: [
    {
      text: "All Invoices",
      path: "/client/invoices",
      icon: invoice,
    },
    {
      text: "Recurring Approvals",
      path: "/client/recurring-approvals",
      icon: Recurring_Approval_icon,
    },
  ],
};

export const COMPANY_SETTINGS = {
  text: "Company Settings",
  icon: company,
  iconLite: companyLite,
  id: "companyLite",
  subLinks: [
    {
      text: "Switch Organizations",
      path: "/client/change-account",
      icon: switchIcon,
    },
    { text: "Settings", path: "/client/settings", icon: settingsIcon },
    { text: "Team Members", path: "/client/team", icon: teamIcon },
    {
      text: "Return to onboarding",
      path: "/welcome-screen",
      icon: onboardIcon,
    },
  ],
};

const ClientsNav = (props) => {
  const isDepositUser = props.user?.type === "DepositUser";
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [hoveredIcon, setHoveredIcon] = useState(null);
  const { selectedNavItem, setSelectedNavItem } = useNavContext();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { progressPercent } = useContext(OnboardingContext);
  const [isDropdownOpenInvoice, setIsDropdownOpenInvoice] = useState(false);
  const companyDropdownCloseRef = useRef(null);
  const invoiceDropdownCloseRef = useRef(null);
  const DROPDOWN_CLOSE_DELAY_MS = 500;

  const clearDropdownCloseTimeout = (timeoutRef) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  const scheduleCompanyDropdownClose = () => {
    clearDropdownCloseTimeout(companyDropdownCloseRef);
    companyDropdownCloseRef.current = setTimeout(() => {
      setIsDropdownOpen(false);
      setHoveredIcon(null);
      companyDropdownCloseRef.current = null;
    }, DROPDOWN_CLOSE_DELAY_MS);
  };

  const scheduleInvoiceDropdownClose = () => {
    clearDropdownCloseTimeout(invoiceDropdownCloseRef);
    invoiceDropdownCloseRef.current = setTimeout(() => {
      setIsDropdownOpenInvoice(false);
      setHoveredIcon(null);
      invoiceDropdownCloseRef.current = null;
    }, DROPDOWN_CLOSE_DELAY_MS);
  };

  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });
  function debounce(fn, ms) {
    let timer;
    return (_) => {
      clearTimeout(timer);
      timer = setTimeout((_) => {
        timer = null;
        fn();
      }, ms);
    };
  }
  useEffect(() => {
    const debouncedHandleResize = debounce(function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    }, 50);

    window.addEventListener("resize", debouncedHandleResize);

    return (_) => {
      window.removeEventListener("resize", debouncedHandleResize);
    };
  }, [dimensions]);

  useEffect(() => {
    return () => {
      clearDropdownCloseTimeout(companyDropdownCloseRef);
      clearDropdownCloseTimeout(invoiceDropdownCloseRef);
    };
  }, []);

  const toggleCollapse = () => {
    setIsCollapsed((prev) => !prev);
    setIsDropdownOpen(false);
    setIsDropdownOpenInvoice(false);
    clearDropdownCloseTimeout(companyDropdownCloseRef);
    clearDropdownCloseTimeout(invoiceDropdownCloseRef);
  };

  const handleMouseEnter = (icon) => {
    setHoveredIcon(icon);
    if (icon === COMPANY_SETTINGS.id) {
      clearDropdownCloseTimeout(companyDropdownCloseRef);
      setIsDropdownOpen(true);
    }
  };

  const handleMouseEnterInvoice = (icon) => {
    setHoveredIcon(icon);
    if (icon === INVOICE.id) {
      clearDropdownCloseTimeout(invoiceDropdownCloseRef);
      setIsDropdownOpenInvoice(true);
    }
  };

  const handleMouseLeave = () => {
    setHoveredIcon(null);
    setIsDropdownOpen(false);
    clearDropdownCloseTimeout(companyDropdownCloseRef);
  };

  const handleCompanySettingsMouseLeave = () => {
    scheduleCompanyDropdownClose();
  };

  const handleMouseLeaveInvoice = () => {
    scheduleInvoiceDropdownClose();
  };

  const handleNavItemClick = (text) => {
    setSelectedNavItem(text);
  };

  const isNavEnabled = isDepositUser || Math.floor(progressPercent) >= 88;
  const homePath = isDepositUser ? "/sales_user/payments" : "/client/dashboard";

  const renderNavLink = (item) => {
    const { text, path, icon, iconLite, id } = item;
    return (
      <Link
        key={text}
        className={`${styles.navLink} ${
          selectedNavItem === text ? styles.active : ""
        }`}
        to={path}
        title={text}
        onMouseEnter={() => handleMouseEnter(id)}
        onMouseLeave={handleMouseLeave}
        style={{
          pointerEvents: isNavEnabled ? "auto" : "none",
          opacity: isNavEnabled ? "1" : "0.5",
        }}
        onClick={() => false && handleNavItemClick(text)}
      >
        <img
          src={
            hoveredIcon === id && selectedNavItem === text
              ? iconLite
              : selectedNavItem !== text
                ? icon
                : iconLite
          }
          className={styles.icon}
          alt={text}
        />
        {!isCollapsed && <span>{text}</span>}
      </Link>
    );
  };
  return (
    <nav className={`${styles.navbar}  ${isCollapsed ? styles.collapsed : ""}`}>
      <div className={styles.upperNav}>
        <Link
          to={homePath}
          className={styles.logoLink}
          title={isDepositUser ? "Payments" : "Dashboard"}
          style={{
            pointerEvents: isNavEnabled ? "auto" : "none",
            opacity: isNavEnabled ? "1" : "0.5",
          }}
        >
          <img src={mkaegoodIcon} className={styles.icon} alt='MakeGood' />
          {!isCollapsed && (
            <img src={mgTextNew} alt='MakeGood' height={40} width={160} />
          )}
        </Link>
        <button
          className={isCollapsed ? styles.toggleButton1 : styles.toggleButton}
          onClick={toggleCollapse}
        >
          <img src={isCollapsed ? collapse1 : collapse2} alt='Toggle' />
        </button>
        {(isDepositUser
          ? NAV_ITEMS.filter((i) => i.text === "Payments").map((i) => ({
              ...i,
              path: i.path.replace("/client/", "/sales_user/"),
            }))
          : NAV_ITEMS
        ).map((item, index) => (
          <React.Fragment key={item.text}>
            {renderNavLink(item)}
            {item.text === "Accounts" && (
              <>
                <button
                  className={
                    isCollapsed ? styles.toggleButton1 : styles.toggleButton
                  }
                  onClick={toggleCollapse}
                >
                  <img src={isCollapsed ? collapse1 : collapse2} alt='Toggle' />
                </button>
                <div style={{ position: "relative" }}>
                  <button
                    className={`${styles.navLink} ${
                      selectedNavItem === "Invoices" ? styles.active : ""
                    }`}
                    onMouseEnter={() => handleMouseEnterInvoice(INVOICE.id)}
                    onMouseLeave={handleMouseLeaveInvoice}
                    style={{
                      pointerEvents:
                        Math.floor(progressPercent) >= 88 ? "auto" : "none",
                      opacity: Math.floor(progressPercent) >= 88 ? "1" : "0.5",
                    }}
                  >
                    <img
                      src={
                        selectedNavItem === "Invoices" &&
                        hoveredIcon === INVOICE.id
                          ? INVOICE.iconLite
                          : selectedNavItem !== "Invoices"
                            ? INVOICE.icon
                            : INVOICE.iconLite
                      }
                      className={styles.icon}
                      width={20}
                      height={20}
                      alt={INVOICE.text}
                    />
                    {!isCollapsed && (
                      <div className={styles.navLinkLabel}>
                        <span style={{ whiteSpace: "nowrap" }}>
                          {INVOICE.text}
                        </span>
                        <img
                          src={
                            selectedNavItem === "Invoices" &&
                            hoveredIcon === INVOICE.id
                              ? iconDown
                              : iconUpLite
                          }
                          width={10}
                          height={10}
                          alt=''
                          className={styles.chevronIcon}
                        />
                      </div>
                    )}
                  </button>
                  {isDropdownOpenInvoice && (
                    <div
                      className={styles.dropdownPopupContainer}
                      onMouseEnter={() => {
                        clearDropdownCloseTimeout(invoiceDropdownCloseRef);
                        setIsDropdownOpenInvoice(true);
                      }}
                      onMouseLeave={handleMouseLeaveInvoice}
                    >
                      <DropdownMenuInvoice />
                    </div>
                  )}
                </div>
              </>
            )}
          </React.Fragment>
        ))}
      </div>

      <div className={styles.bottomNav}>
        {!props?.disableNav && !isDepositUser && (
          <div className={styles.bottomNavItem}>
            <Link
              className={`${styles.navLink} ${selectedNavItem === "Company Settings" ? styles.active : ""}`}
              to={Math.floor(progressPercent) >= 88 ? "" : "/welcome-screen"}
              onMouseEnter={() => {
                if (Math.floor(progressPercent) >= 88) {
                  handleMouseEnter(COMPANY_SETTINGS.id);
                }
              }}
              onMouseLeave={() => {
                if (Math.floor(progressPercent) >= 88) {
                  handleCompanySettingsMouseLeave();
                }
              }}
              style={{
                pointerEvents:
                  Math.floor(progressPercent) >= 88 ? "auto" : "none",
                opacity: Math.floor(progressPercent) >= 88 ? "1" : "0.5",
              }}
            >
              <img
                src={
                  selectedNavItem === "Company Settings" &&
                  hoveredIcon === COMPANY_SETTINGS.id
                    ? COMPANY_SETTINGS.iconLite
                    : selectedNavItem !== "Company Settings"
                      ? COMPANY_SETTINGS.icon
                      : COMPANY_SETTINGS.iconLite
                }
                className={styles.icon}
                width={20}
                height={20}
                alt={COMPANY_SETTINGS.text}
              />
              {!isCollapsed && (
                <div className={styles.navLinkLabel}>
                  <span style={{ whiteSpace: "nowrap" }}>
                    {COMPANY_SETTINGS.text}
                  </span>
                  <img
                    src={
                      selectedNavItem === "Company Settings" &&
                      hoveredIcon === COMPANY_SETTINGS.id
                        ? iconDown
                        : iconUpLite
                    }
                    width={10}
                    height={10}
                    alt=''
                    className={styles.chevronIcon}
                  />
                </div>
              )}
            </Link>
            {isDropdownOpen && (
              <div
                className={styles.dropdownPopupContainerAbove}
                onMouseEnter={() => {
                  clearDropdownCloseTimeout(companyDropdownCloseRef);
                  setIsDropdownOpen(true);
                }}
                onMouseLeave={handleCompanySettingsMouseLeave}
              >
                <DropdownMenu />
              </div>
            )}
          </div>
        )}

        <Link
          className={styles.navLink}
          to='/sign-out'
          title='Sign-out'
          onMouseEnter={() => handleMouseEnter("logoutLite")}
          onMouseLeave={handleMouseLeave}
          onClick={() => handleNavItemClick("Dashboard")}
        >
          <img
            src={logout}
            className={styles.icon}
            width={20}
            height={20}
            alt='Logout'
          />
          {!isCollapsed && <span>Logout</span>}
        </Link>
      </div>
    </nav>
  );
};

const DropdownMenu = () => {
  return (
    <div className={styles.dropdownMenu}>
      {COMPANY_SETTINGS.subLinks.map((link, index) => (
        <Link to={link.path} className={styles.dropdownItem} key={index}>
          <img src={link.icon} width={20} height={20} alt={link.text} />
          <span>{link.text}</span>
        </Link>
      ))}
    </div>
  );
};

const DropdownMenuInvoice = () => {
  return (
    <div className={styles.dropdownMenu}>
      {INVOICE.subLink.map((link, index) => (
        <Link to={link.path} className={styles.dropdownItem} key={index}>
          <img src={link.icon} width={20} height={20} alt={link.text} />
          <span>{link.text}</span>
        </Link>
      ))}
    </div>
  );
};

ClientsNav.propTypes = {
  path: PropTypes.string.isRequired,
};

export default ClientsNav;
